import { defineCustomElement } from 'vue'
import TcChat from './TcChat.ce.vue'

/**
 * Registra <tc-chat> como Web Component nativo (Shadow DOM).
 *
 * Uso desde el sitio host:
 *   <script src="https://.../widget.js" async></script>
 *
 * Se auto-inicializa: crea <tc-chat> y lo agrega al <body>. Para montarlo
 * a mano, agrega data-auto-init="false" a cualquier <script> de la página.
 */
const TcChatElement = defineCustomElement(TcChat)

if (!customElements.get('tc-chat')) {
  customElements.define('tc-chat', TcChatElement)
}

function autoInitDisabled(): boolean {
  return !!document.querySelector('script[data-auto-init="false"]')
}

function autoInit(): void {
  if (autoInitDisabled()) return
  if (document.querySelector('tc-chat')) return
  const el = document.createElement('tc-chat')
  document.body.appendChild(el)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', autoInit)
} else {
  autoInit()
}
